import React from "react";

// this is the list of all products in the inventory
// It will be displayed in a table format
// Each row is clickable and will take the user to the product details page
// The user can also add a new product to the inventory on this page
// The user can also delete a product from the inventory on this page

// components
import CardTable from "components/Tables/CardTable.js";

export default function Products() {
    return (
        <>
            <div className="flex flex-wrap mt-4 z-10">
                <div className="w-full mb-12 px-4">
                    <CardTable
                        color="light"
                        heading="Products"
                        route="/admin/products/create"
                        columns={[
                            { label: "Name", key: "name", render: (value) => <b>{value}</b> },
                            { label: "Category", key: "productCategory" },
                            { label: "Quantity", key: "quantity", render: (value) => <span>{value}</span> },
                            { label: "Status", key: "status", render: (value) => <span>{value}</span> },
                        ]}
                        data={[
                            {
                                name: "Organic Avocados",
                                productCategory: "Fruits & Vegetables",
                                quantity: 100,
                                status: "In Stock",
                            },
                            {
                                name: "Almond Milk",
                                productCategory: "Dairy Alternatives",
                                quantity: 50,
                                status: "In Stock",
                            },
                            {
                                name: "Whole Wheat Bread",
                                productCategory: "Bakery",
                                quantity: 0,
                                status: "Out of Stock",
                            },
                            {
                                name: "Organic Tomatoes",
                                productCategory: "Fruits & Vegetables",
                                quantity: 150,
                                status: "In Stock",
                            },
                            {
                                name: "Granola Bars",
                                productCategory: "Snacks",
                                quantity: 200,
                                status: "In Stock",
                            },
                            {
                                name: "Chickpeas (Canned)",
                                productCategory: "Canned Goods",
                                quantity: 120,
                                status: "In Stock",
                            },
                        ]}
                    />

                </div>
            </div>
        </>
    );
}